import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../helpers/EventEmitter'
import { handleExport } from '../../../../helpers/export'
import UserManagementService from '../../../store/services/UserManagementService'

export const getSubscriptionAndPackageOrdersPaged = createAsyncThunk(
  'userManagement/getSubscriptionAndPackageOrdersPaged',
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await UserManagementService.getSubscriptionAndPackageOrdersPaged(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSubscriptionAndPackageOrdersTypes = createAsyncThunk(
  'userManagement/getSubscriptionAndPackageOrdersTypes',
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await UserManagementService.getSubscriptionAndPackageOrdersTypes(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSubscriptionAndPackageOrdersById = createAsyncThunk(
  'userManagement/getSubscriptionAndPackageOrdersById',
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await UserManagementService.getSubscriptionAndPackageOrdersById(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDetailRequestContract = createAsyncThunk(
  'userManagement/getDetailRequestContract',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getDetailRequestContract(
        params,
      )
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDetailRequestConfirmation = createAsyncThunk(
  'userManagement/getDetailRequestConfirmation',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getDetailRequestConfirmation(
        params,
      )
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const postCancelRequestOrder = createAsyncThunk(
  'userManagement/postCancelRequestOrder',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.postCancelRequestOrder(
        params,
      )

      if (response?.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'userManagement.orderManagement.orderDetail.CONFIRM_CANCEL_REQUEST_MESS',
        )

        return response
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getSNPNewTransactionPreview = createAsyncThunk(
  'userManagement/getSNPNewTransactionPreview',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getSNPNewTransactionPreview(
        params,
      )
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
